import { Alert, Button } from "reactstrap";
import { DataTransforms, Module } from "../../../types/TenantInterfaces";
import AppDrawer from "../AppDrawer";
import CreateRecordRendererV2 from "../../Records/CreateRecordRendererV2";
import { useMemo, useState } from "react";
import { GetDefaultLayout } from "./ModuleLayoutSelector";
import { transformData } from "../../../utils/DataTransformsUtils";
import AppSpinner from "../../../elements/AppSpinner";

interface Props {
  open: boolean;
  dataTransform: DataTransforms;
  sourceModule: Module;
  targetModule: Module;
  currentData: any;
  error?: {
    error: string;
    clear: () => void;
  };
  loading?: boolean;
  onSaveRecord: (values: any) => void;
  onClose: () => void;
  clearError?: () => void;
}

const empty: [] = [];

const TransformRecordEditDrawer = ({
  open,
  dataTransform,
  targetModule,
  currentData,
  error,
  loading,
  onClose,
  onSaveRecord,
  clearError,
}: Props) => {
  const [values, setValues] = useState<Record<string, any>>({});
  const defaultLayout = useMemo(
    () => (targetModule ? GetDefaultLayout(targetModule) : null),
    [targetModule]
  );

  const prefilledValues = useMemo(() => {
    if (!currentData) return;
    return transformData(currentData, dataTransform);
  }, [currentData]);

  return (
    <AppDrawer
      size="md"
      placement="right"
      open={open}
      onClose={onClose}
      backdrop={"static"}
      headerTitle={`Creating New ${dataTransform.TargetModule} from ${dataTransform?.SourceModule}`}
      headerOptions={
        <Button
          onClick={() => {
            onSaveRecord(values);
          }}
          color="primary"
          size="sm"
          style={{ width: 80 }}
        >
          Save
        </Button>
      }
      body={
        <>
          {loading ? (
            <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:h-full">
              <AppSpinner
                size="xl"
                style={{ width: "40px", height: "40px" }}
                color="primary"
                className="tw:my-4"
              />
              <strong>Transforming your data</strong>
            </div>
          ) : (
            <CreateRecordRendererV2
              module={targetModule}
              layout={defaultLayout}
              prefill={prefilledValues || empty}
              onChange={(values) => {
                setValues(values);
                clearError && clearError();
              }}
              variableValues={undefined}
            />
          )}

          {error && (
            <Alert color="danger" isOpen toggle={error.clear} className="mt-2">
              {error.error}
            </Alert>
          )}
        </>
      }
    />
  );
};

export default TransformRecordEditDrawer;
